import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { IMPACT_ACTION_PLAN_STATUSES } from '../../../../lib/schema.js';
import RadioOptionsField from '../../../RadioOptionsField.jsx';

const options = IMPACT_ACTION_PLAN_STATUSES.map((type) => ({
  label: type,
  value: type,
}));

ActionPlanStatusField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

function ActionPlanStatusField({ label, name }) {
  return (
    <RadioOptionsField
      id={`ChangeImpactForm${capitalize(name)}`}
      label={label}
      name={name}
      options={options}
    />
  );
}

export default ActionPlanStatusField;
